import Uppy from "@uppy/core";
import AwsS3 from "@uppy/aws-s3";

export function uppyInstance() {
  return new Uppy({
    autoProceed: true,
    debug: false,
    allowMultipleUploads: false,
    restrictions: {
      // allowedFileTypes: null,
    },
    onBeforeUpload(files) {},
  }).use(AwsS3, {
    endpoint: "/", // will call Shrine's presign endpoint mounted on `/s3/params`
  });
}

export function uploadedFileData(file) {
  let id = file.s3Multipart["key"].match(/^cache\/(.+)/)[1];
  return JSON.stringify(fileData(file, id));
}

// constructs uploaded file data in the format that Shrine expects
function fileData(file, id) {
  return {
    id: id,
    storage: "cache",
    metadata: {
      size: file.size,
      filename: file.name,
      mime_type: file.type,
    },
  };
}
